import { type ColumnId } from '../canvas-element/slots';

export const SLOT_MINIMAL_WIDTH = '16px';
export type NewColumnPlacement = 'before-slot' | 'after-slot';

export interface ColumnResizeData {
  slotId: ColumnId;
  width: number;
  widthPercent: number;
  minWidth: number;
  minWidthPercent: number;
  maxWidth: number;
  maxWidthPercent: number;
}
